import store from 'redux/store';

enum UserType {
	MANAGER = 'MANAGER',
	SUPER_ADMIN = 'SUPERADMIN',
	ADMIN = 'ADMIN',
}

export const permissions: { [id: string]: string[] } = {
	default: [UserType.ADMIN, UserType.SUPER_ADMIN],
	all: [UserType.ADMIN, UserType.SUPER_ADMIN, UserType.MANAGER],
	'services:add_services': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'payment:pay_bills': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'payment:bills': [UserType.MANAGER],
	'sidebar:orders': [UserType.ADMIN, UserType.MANAGER, UserType.SUPER_ADMIN],
	'services:prepaid_loyalty': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'payment:service_requests': [UserType.SUPER_ADMIN, UserType.ADMIN],
	'sidebar:purchase-device-history': [UserType.SUPER_ADMIN, UserType.ADMIN],
	'services:purchase_device': [UserType.SUPER_ADMIN, UserType.ADMIN],
	'dashboard:info-can-be-missed': [UserType.MANAGER],
	'services:try_and_buy': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'services:active_services': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'dashboard:my-aamali-plus': [UserType.ADMIN, UserType.SUPER_ADMIN, UserType.MANAGER],
	'dashboard:bankmuskat': [UserType.ADMIN, UserType.SUPER_ADMIN, UserType.MANAGER],
	'dashboard:try-and-buy-try-now': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'department:edit-expiration-date': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'department:add-manager': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'department:edit-department': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'departments:add-numbers': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'departments:add-department': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'organizations:add-admin': [UserType.SUPER_ADMIN],
	'organization:edit-admins': [UserType.SUPER_ADMIN],
	'organizations:add-manager': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'organization:edit-photo': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'organization:edit-or-see-admins': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'organization:edit-managers': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'organization-managers:delete-managers': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'organization-admins:delete-admins': [UserType.SUPER_ADMIN],
	'organization:see-manager-details': [UserType.ADMIN, UserType.SUPER_ADMIN, UserType.MANAGER],
	'organization:see-admin-details': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'user-details:edit-superadmin-user': [UserType.SUPER_ADMIN],
	'user-details:edit-admin-user': [UserType.SUPER_ADMIN],
	'user-details:edit-manager-user': [UserType.SUPER_ADMIN, UserType.ADMIN],
	'user-details:edit-enduser-user': [UserType.SUPER_ADMIN, UserType.ADMIN],
	'user-details:resend-admin-activation-email': [UserType.SUPER_ADMIN],
	'user-details:resend-manager-activation-email': [UserType.SUPER_ADMIN, UserType.ADMIN],
	'user-numbers:add-number': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'user-numbers:detach-numbers': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'number-details:see': [UserType.ADMIN, UserType.SUPER_ADMIN, UserType.MANAGER],
	'number-details:assign-user': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'number-details:see-billing-account-details': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'number-details:detach-user': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'number-usage:see': [UserType.ADMIN, UserType.SUPER_ADMIN, UserType.MANAGER],
	'number-usage:see-call-details': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'number-services:see': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'number-sim-management:see': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'number-settings:see': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'number-aaamaliplus-services:see': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'number-active-commitments:see': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'users:add-user': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'users:import-csv': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'users:delete-users': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'users:add-numbers': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'users:add-admin': [UserType.SUPER_ADMIN],
	'organization:edit-organization-address': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'organization:edit-organization-tax-id': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'active-services:add-billing-account': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'active-services:delete-billing-account': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'active-services:edit-billing-account-edit-ebill-recipient': [UserType.SUPER_ADMIN],
	'active-services:edit-billing-account-add-ebill-recipient': [UserType.SUPER_ADMIN],
	'prepaid-loyalty:add-group': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'prepaid-loyalty:add-top-up': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'prepaid-loyalty:add-services': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'prepaid-loyalty:delete-group': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'prepaid-loyalty:group-details-change-group-name': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'prepaid-loyalty:group-details-add-numbers': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'prepaid-loyalty:group-details-save-cancel-buttons': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'prepaid-loyalty:group-details-delete-numbers': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'billing-payment-track:add-new-offline-payment': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'prepaid-loyalty:add-numbers-buttons-description': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'user-billing-accounts:add-billing-account': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'user-bills:download-request': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'user-bills:pay-bills': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'upgrade:nama-upgrade': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'profile:change_email': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'profile:change_number': [UserType.ADMIN, UserType.SUPER_ADMIN],
	'profile:change_password': [UserType.ADMIN, UserType.SUPER_ADMIN, UserType.MANAGER],
	insights: [UserType.ADMIN, UserType.SUPER_ADMIN],
};

export function hasPermission(userType: string, action: string): boolean {
	const permissions = store.getState().settings.appConfig.permissions;
	return permissions[action]?.indexOf(userType) >= 0;
}

interface User {
	departmentId?: string;
	accountId?: string;
}

interface Permission {
	accountId: string;
	departmentId: string;
}

export function hasAccess(
	user: User,
	loggedUserType: string,
	accountPermissions: Permission[] = [],
	departmentPermissions: Permission[] = []
): boolean {
	if (loggedUserType === 'SUPERADMIN') return true;
	if (loggedUserType === 'ADMIN')
		return accountPermissions.some((permission) => permission.accountId === user.accountId);
	if (loggedUserType === 'MANAGER')
		return departmentPermissions.some((permission) => permission.departmentId === user.departmentId);
	return false;
}
